import { apiInstance } from '@/api/api.js'
const api = apiInstance()

export default {
  async getPractices({ state, commit, dispatch }, params) {
    params = params || state.practicesFilters
    try {
      commit('setLoading', true)
      const response = await api.get('/practices', { params })
      commit('setPracticesFilters', params)
      commit('setPractices', response.data.practices)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getPractice({ commit, dispatch }, id) {
    const url = `/practices/${id}`

    try {
      commit('setLoading', true)
      const response = await api.get(url)
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setPractice', response.data)
      commit('appStates/setBreadcrumbCurrentView', response.data.name, {
        root: true,
      })
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getRawPractice({ commit, dispatch }, id) {
    const url = `/practices/${id}`

    try {
      const response = await api.get(url)
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      return response.data
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      return null
    }
  },
  async addPractice({ commit, dispatch }, data) {
    try {
      commit('setLoading', true)
      await api.post('/practices', data)
      await dispatch('getPractices')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'New Company Added!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async deletePractice({ commit, dispatch, rootState }, id) {
    const url = `/practices/${id}`
    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      await api.delete(url, {
        headers: { 'If-Match': headersStates.headersEtag[url] },
      })
      await dispatch('getPractices')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Company deleted!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async changePracticeField(
    { state, commit, rootState, dispatch },
    { id, key, value },
  ) {
    const url = `/practices/${id}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      const response = await api.put(
        url,
        { ...state.practice, [key]: value },
        { headers: { 'If-Match': headersStates.headersEtag[url] } },
      )
      commit('setPractice', response.data)
      commit('appStates/setBreadcrumbCurrentView', response.data.name, {
        root: true,
      })
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Saved!', { root: true })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async changePracticeFeatureFlag(
    { state, dispatch, commit, rootState },
    { id, key, value },
  ) {
    const url = `/practices/${id}/featureFlag`
    const practiceUrl = `/practices/${id}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)

      let practiceFeatureFlagData = {
        journalAvailable: state.practice.journalAvailable,
        smartSurveyAvailable: state.practice.smartSurveyAvailable,
        swapAvailable: state.practice.swapAvailable,
        surveyAvailable: state.practice.surveyAvailable,
      }
      practiceFeatureFlagData[key] = value

      const response = await api.put(url, practiceFeatureFlagData, {
        headers: { 'If-Match': headersStates.headersEtag[practiceUrl] },
      })
      await dispatch('getPractice', id)
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Saved!', { root: true })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      await dispatch('getPractice', id)
      commit('setLoading', false)
    }
  },
  async updatePracticePicture({ commit, rootState, dispatch }, { id, file }) {
    const url = `/practices/${id}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)

      let formData = new FormData()
      if (file) {
        formData.append('file', file.file, file.name)
      }

      const response = await api.put(url + '/picture', formData, {
        headers: {
          'If-Match': headersStates.headersEtag[url],
          'Content-Type': 'multipart/form-data',
        },
      })
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Saved!', { root: true })
      await dispatch('getPractice', id)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getPracticePatients({ state, commit, dispatch }, { id, params }) {
    params = params || state.practicePatientsFilters
    try {
      commit('setLoading', true)
      const response = await api.get(`/participants?practiceId=${id}`, {
        params,
      })
      commit('setPracticePatientsFilters', params)
      commit('setPracticePatients', response.data.participants)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getPracticeUsers(
    { state, commit, dispatch },
    { id, params, returnData = false },
  ) {
    params = params || state.practiceUsersFilters
    try {
      commit('setLoading', true)
      const response = await api.get(`/practices/${id}/users`, { params })

      if (returnData) {
        commit('setLoading', false)
        return response.data.users
      }
      commit('setPracticeUsersFilters', params)
      commit('setPracticeUsers', response.data.users)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getPracticeUser({ commit, dispatch }, { practiceId, userId }) {
    const url = `/practices/${practiceId}/users/${userId}`

    try {
      commit('setLoading', true)
      const response = await api.get(url)
      commit('setPracticeUser', response.data)
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async addPracticeUser({ commit, dispatch }, { id, data }) {
    try {
      commit('setLoading', true)
      await api.post('/practices/' + id + '/users', data)
      await dispatch('getPracticeUsers', { id })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'New Company User Added!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async changePracticeUser(
    { rootState, commit, dispatch },
    { practiceId, userId, data },
  ) {
    const url = `/practices/${practiceId}/users/${userId}`

    try {
      let id = practiceId
      const { headersStates } = rootState
      commit('setLoading', true)
      const response = await api.put(url, data, {
        headers: { 'If-Match': headersStates.headersEtag[url] },
      })
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      await dispatch('getPracticeUsers', { id })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Company User edited!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async changePracticeUserFeatureFlag(
    { state, dispatch, commit, rootState },
    { practiceId, userId, key, value },
  ) {
    const url = `/practices/${practiceId}/users/${userId}/featureFlag`
    const practiceUserUrl = `/practices/${practiceId}/users/${userId}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)

      let practiceFeatureFlagData = {
        surveyAvailable: state.practice.surveyAvailable,
      }
      practiceFeatureFlagData[key] = value

      const response = await api.put(url, practiceFeatureFlagData, {
        headers: { 'If-Match': headersStates.headersEtag[practiceUserUrl] },
      })
      await dispatch('getPracticeUser', { practiceId, userId })
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Saved!', { root: true })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      await dispatch('getPracticeUser', { practiceId, userId })
      commit('setLoading', false)
    }
  },
  async getPracticeUserPatients({ commit, dispatch }, params) {
    try {
      commit('setLoading', true)
      const response = await api.get(`/participants`, { params })
      commit('setPracticeUserPatients', response.data.participants)
      commit('setPracticeUserPatientsPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async addPracticePatient({ state, commit, dispatch }, { id, data }) {
    try {
      commit('setLoading', true)
      await api.post('/participants', {
        ...state.currentPatient,
        ...data,
      })
      await dispatch('getPracticePatients', { id: id })
      commit('setLoading', false)
      commit(
        'appStates/setSnackbarNotification',
        'New Company Participant Added!',
        { root: true },
      )
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getPracticeUserAdvisorsDashboard(
    { state, commit, dispatch },
    { range = '', showAll = false },
  ) {
    const params = new URLSearchParams()
    if (['today', 'week', 'month', 'year'].includes(range)) {
      params.append('filter', range)
    }

    params.append('showAll', showAll === true)

    try {
      commit('setLoading', true)
      const response = await api.get('/advisors/dashboard', { params })
      commit('setPracticeUserAdvisorsDashboard', response.data)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
}
